import { render, staticRenderFns } from "./Verification.vue?vue&type=template&id=224991b2&scoped=true"
import script from "./Verification.vue?vue&type=script&lang=ts"
export * from "./Verification.vue?vue&type=script&lang=ts"
import style0 from "./Verification.vue?vue&type=style&index=0&id=224991b2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "224991b2",
  null
  
)

export default component.exports